<template>
  <div class="base_detail_modal"  >
     
    <Modal    
          v-model="detailModal"
          :title="`【${houseDetail['房屋地址']}】房源详情`" 
            :width="screenWidth*0.8"
          @on-cancel="cancel" @on-visible-change="changeModal">
          <div class="base-modal"> 
            <Tabs value="1" v-if="detailModal">
              <TabPane label="基础信息" name="1">
                <VuePerfectScrollbar style=" display: block;height:500px ;overflow:auto;"> 
                  
                  <div v-for="(key, index) in keyList" :key="key " >
                    <template  v-if="isPrimitive(key) && index % 2 == 0 " >
                      <div class="base-modal-line" :style="index==0?'border-top:1px solid #c3c3c3':''"> 
                        <div   class="item_1" > 
                          <!-- :style="getMaxLineHeight(index)" -->
                          <div class="item_1-title" >{{ keyList[index] }}:</div>
                          <div class="item_1-value">{{ houseDetail[keyList[index]] }}</div>
                        </div>
                        <div   class="item_1"  > 
                          <!--  :style="getMaxLineHeight(index)" -->
                          <div class="item_1-title">{{ keyList[index+1] }}:</div>
                          <div class="item_1-value">{{ houseDetail[keyList[index+1]] }}</div>
                        </div>
                      </div>

                    </template>
                    
                  </div> 
                    
              </VuePerfectScrollbar>
                
              </TabPane>
              <TabPane label="房屋照片" name="2">
                <VuePerfectScrollbar style=" display: block;height:600px ;overflow:auto;"> 
               
                  <div v-for="(key, index) in ['客厅照片','卧室照片','厨房照片','卫生间照片','其他照片']" :key="key " :style="index==0?'':'margin-top:20px;'"> 
                    <template  > 
                      <Alert>{{ key }} </Alert>      
                      <div v-if="getImage(key).length==0">暂无照片</div>
                      <div style="display: flex;gap:30px;" v-else>
                        <el-image   v-for="(item,index) in getImage(key)"  :key="item" 
                        style="width: 300px; height: 300px"
                        :src="getImage(key)[index]" 
                        :preview-src-list="getImage(key)">
                      </el-image>
                      </div>  
                    </template> 
                  </div>  
              </VuePerfectScrollbar>
                
              </TabPane>
              <TabPane label="房屋托管合同信息" name="3">
                <VuePerfectScrollbar style=" display: block;height:600px ;overflow:auto;">  
                    <template  > 
                      <Alert>房屋托管合同信息</Alert>   
                      <div v-if="getImage('房屋托管合同信息')==0">暂无照片</div>
                      <div style="display: flex;gap:30px;" v-else>
                        <el-image   v-for="(item,index) in getImage('房屋托管合同信息')"  :key="item" 
                        style="width: 300px; height: 300px"
                        :src="item" 
                        :preview-src-list="getImage('房屋托管合同信息')">
                      </el-image>
                      </div>  
                    </template>  
              </VuePerfectScrollbar>
                
              </TabPane>
              <TabPane label="产证信息" name="4">
                <VuePerfectScrollbar style=" display: block;height:600px ;overflow:auto;"> 
                  <template  > 
                      <Alert>产证信息</Alert>   
                      <div v-if="getImage('产证信息')==0">暂无照片</div>
                      <div style="display: flex;gap:30px;" v-else>
                        <el-image   v-for="(item,index) in getImage('产证信息')"  :key="item" 
                        style="width: 300px; height: 300px"
                        :src="item" 
                        :preview-src-list="getImage('产证信息')">
                      </el-image>
                      </div>  
                    </template> 
              </VuePerfectScrollbar>
                
              </TabPane>
              <TabPane label="身份证信息" name="5">
                <VuePerfectScrollbar style=" display: block;height:600px ;overflow:auto;"> 
                  <template  > 
                      <Alert>身份证信息</Alert>   
                      <div v-if="getImage('身份证信息')==0">暂无照片</div>
                      <div style="display: flex;gap:30px;" v-else>
                        <el-image   v-for="(item,index) in getImage('身份证信息')"  :key="item" :zoom-rate="1.0"
                        style="width: 300px; height: 300px"
                        :src="item" 
                        :preview-src-list="getImage('身份证信息')">
                      </el-image>
                      </div>  
                    </template> 
999
                    <img v-for="item in getImage('身份证信息')" :key="item" :src="item" />
              </VuePerfectScrollbar>
                
              </TabPane>
              <TabPane label="其他信息" name="6">
                <VuePerfectScrollbar style=" display: block;height:600px ;overflow:auto;">  
               
                  <div v-for="(key, index) in otherKeyList" :key="key " > 
                    <template  v-if="index % 2 == 0 " >
                      <div class="base-modal-line" :style="index==0?'border-top:1px solid #c3c3c3':''"> 
                        <div   class="item_1" > 
                          <div class="item_1-title" :style="getMaxLineHeight2(index)">{{ otherKeyList[index] }}:</div>
                          <div class="item_1-value">{{ houseDetail[otherKeyList[index]] }}</div>
                        </div>
                        <div   class="item_1"  > 
                          <div class="item_1-title" :style="getMaxLineHeight2(index)">{{ otherKeyList[index+1] }}:</div>
                          <div class="item_1-value">{{ houseDetail[otherKeyList[index+1]] }}</div>
                        </div>
                      </div>

                    </template>
                    
                  </div> 
                    
              </VuePerfectScrollbar>
              </TabPane>
              <!-- <TabPane label="视频资料" name="7">
                <div v-for="(video, index) in getImage('装修视频')" :key="index" class="video-item">
                  <video
                    :src="video.url"
                    controls
                    width="90%"
                    height="42%"
                  
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </TabPane> -->
          </Tabs>

          
          </div>

    </Modal>

  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js"; 
import {utilTools} from "@/utils/js/utilTools.js"
import { get } from 'lodash';
export default {
  name:"base_detail_modal",
  comments:{VuePerfectScrollbar},
  props:{
    houseDetail:{
      type:Object,
      default:{},
    },
    photoKeyList:{
      type:Array,
      default:[]
    },
    otherKeyList:{
      type:Array,
      default:[]
    },
    keyList:{
      type:Array,
      default:[]
    }
  },
    data() {
        return { 
          imgBaseUrl:"https://mp.xiaojiabiyu.net.cn/cms/v1/files/transform?uri=",
          detailModal:false,//控制弹窗开关 
          keyNotShow:["id","clsId","dataFieldMap","ciSource","tVersion","ciStatus","viewId","tenant"],
          houseDetailShow:{},
          czImgList:[],
          sfzImgList:[],
          fwtghtImgList:[],
          sqhtsImgList:[],

          ktImgList:[],
          cfImgList:[],
          wsImgList:[],
          wsjImgList:[],
          qtImgList:[],

          zxspList:[],
          

        }
    },
    computed: {
      
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    mounted(){
      
    },
    created(){  
    
      // this.$nextTick(()=>{
      //   this.houseDetail = this.cleanData(this.houseDetail, this.keyNotShow);
      // })
      
     


    },
   
    watch:{},
    methods:{
      changeModal(visible){
        if(visible){
          this.multipleCleanPhotoList(["客厅照片","卧室照片","厨房照片","卫生间照片","其他照片"],"房屋原貌")
          this.cleanPhotoListV2("房屋托管合同信息")
          this.cleanPhotoListV2("产证信息")
          this.cleanPhotoListV2("身份证信息")
          this.cleanPhotoListV2("授权委托书")
          // this.getVideo("装修视频")
        }
      },
      cleanData(obj, properties) { 
        // console.log("obj===",obj)
        properties.forEach(property => {
          delete obj[property];
        }); 
        return obj;
      },
      // 判断是否为普通值（字符串、数字等）
      isPrimitive(key) { 
        let value = this.houseDetail[key]
          return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
        },
        // 判断是否为数组
        isArray(key) {
          let value = this.houseDetail[key]
          return Array.isArray(value) && value.every((item) => typeof item !== "object");
        },
        // 判断是否为对象数组
        isArrayOfObjects(key) {
          let value = this.houseDetail[key] 
          return Array.isArray(value) && value.every((item) => typeof item === "object");
        },
        // 判断是否为对象
        isObject(key) {
          let value = this.houseDetail[key]
          return typeof value === "object" && !Array.isArray(value) && value !== null;
        },
        // 动态生成表格列
        getColumns(array) {
          if (!array.length) return [];
          return Object.keys(array[0]).map((key) => ({
            title: key,
            key: key,
          }));
        },
             // 新版清洗照片--房间照片专属(批量)（新旧系统一起获取）
       multipleCleanPhotoList(key,dataName){
       
      
        key.forEach((itemKey)=>{ 
          let data= []
         if(this.houseDetail[itemKey]!=null&&this.houseDetail[itemKey]!=undefined){
          let data_field_map=JSON.parse(this.houseDetail[itemKey]) 
          if (data_field_map==""||data_field_map==null||data_field_map== undefined) {
            return;
          }
          else{
            data_field_map.forEach((i)=>{
              // let old_obj={
              //   show_name:"(旧系统)"+i.fileName,
              //   type_2:itemKey,
              //   img:this.imgBaseUrl + i.fileAddress,
              //   suffix:i.fileType.split("/")[1], 
              //   source:"old_system",
              //   id:null
              // }
              data.push(this.imgBaseUrl + i.fileAddress);
            })
            
          }

         }
          console.log("key=="+key)
          console.log("data=="+data)
         this.saveImage(itemKey,data)
        }) 
      
      
         
      },
          // 新版清洗照片（新旧系统一起获取）
          cleanPhotoListV2(key){
            let data= []
          // 旧系统
          if(this.houseDetail[key]!=null&&this.houseDetail[key]!=undefined){
            let data_field_map=JSON.parse(this.houseDetail[key])
         
          if(data_field_map==null||data_field_map==''||data_field_map==undefined){
            this.saveImage(key,data)
          }else{
              data_field_map.forEach((i)=>{
                
                // let old_obj={
                //   show_name:"(旧系统)"+i.fileName,
                //   type_2:key,
                //   img:this.imgBaseUrl + i.fileAddress,
                //   suffix:i.fileType.split("/")[1], 
                //   source:"old_system",
                //   id:null
                // }
                data.push(this.imgBaseUrl + i.fileAddress);
              })
              console.log("照片们===",data)
              this.saveImage(key,data)
            
          }

          }
        
        
          
        },
      // 获取视频（部分存在视频的情况）
      getVideo(key){
        let data= []
          //  新系统
          zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:key+"-视频",}).then((res)=>{
            console.log(key,"--查询结果--",res)
            res.data.list.forEach((i)=>{
                let new_obj={
                      show_name:i.show_name,
                      type_2:i.type_2,
                      url:"http://localhost:8080/xjby/view/" + i.show_path,
                      suffix:i.suffix, 
                      source:"new_system",
                      id:i.id
                    }
                    data.push(new_obj);
              })
          })
          // 旧系统
          // console.log("this.houseDetail==",this.houseDetail)
          let data_field_map=JSON.parse(this.houseDetail.data_field_map)
          console.log("data_field_map[key]==",data_field_map[key])
          if(this.houseDetail.data_field_map==null||this.houseDetail.data_field_map==''||this.houseDetail.data_field_map==undefined){
            this.saveImage(key,data)
          }else{
          
            console.log("data_field_map==",data_field_map)
            if (data_field_map[key]==""||data_field_map[key]==null||data_field_map[key]== undefined) {
              this.saveImage(key,data)
            }
            else{
              
              data_field_map[key].forEach((i)=>{
                let old_obj={
                  show_name:"(旧系统)"+i.fileName,
                  type_2:key,
                  url:this.imgBaseUrl + i.fileAddress,
                  suffix:i.fileType.split("/")[1], 
                  source:"old_system",
                  id:null
                }
                data.push(old_obj);
              })
              console.log("照片们===",data)
              this.saveImage(key,data)
            }
          }

      },
        // 存放照片
        saveImage(key,data){
      
          if(key==="客厅照片"){ this.ktImgList=data }
          else if(key==="卧室照片"){ this.wsImgList=data }
          else if(key==="厨房照片"){ this.cfImgList=data }
          else if(key==="卫生间照片"){ this.wsjImgList=data }
          else if(key==="其他照片"){ this.qtImgList=data }

          else if(key==="房屋托管合同信息"){ this.fwtghtImgList=data }
          else if(key==="产证信息"){ this.czImgList=data }
          else if(key==="身份证信息"){ this.sfzImgList=data }
          else if(key==="授权委托书"){ this.sqhtsImgList=data } 
          else if(key==="装修视频"){ this.zxspList=data } 
          

        },
        getImage(key){
          if(key==="客厅照片"){return this.ktImgList ;}
          else if(key==="卧室照片"){ return this.wsImgList ; }
          else if(key==="厨房照片"){ return this.cfImgList ; }
          else if(key==="卫生间照片"){ return this.wsjImgList ; }
          else if(key==="其他照片"){ return this.qtImgList ; }

          else if(key==="房屋托管合同信息"){ return this.fwtghtImgList ;  }
          else if(key==="产证信息"){  return this.czImgList ; }
          else if(key==="身份证信息"){ return this.sfzImgList ;  }
          else if(key==="授权委托书"){ return this.sqhtsImgList ;  } 
          else if(key==="装修视频"){  return this.zxspList ; } 
          else{
            return [];
          }
        },

        getHeight(value) {
          if (value == null) {
            return 50;
          }

        const processedValue = value.toString().replace(/\s+/g, ',');

          const length = processedValue.length; 
          const lines = Math.ceil(length / 28);
          return lines * 50;
        },
        getMaxLineHeight(index) {
          // console.log("key--",this.keyList[index])
          // console.log("value-",this.houseDetail[this.keyList[index]])
  
          const height1 = this.getHeight(this.houseDetail[this.keyList[index]]);
          // console.log("height1--",height1)
          const height2 = this.getHeight(this.houseDetail[this.keyList[index + 1]]);
          // console.log("height2--",height2)
          const maxHeight = Math.max(height1, height2);
          return { height: maxHeight + 'px', lineHeight: maxHeight + 'px' };
        },
        getMaxLineHeight2(index) {
          const height1 = this.getHeight(this.houseDetail[this.otherKeyList[index]]);
          const height2 = this.getHeight(this.houseDetail[this.otherKeyList[index + 1]]);
          const maxHeight = Math.max(height1, height2);
          return { height: maxHeight + 'px', lineHeight: maxHeight + 'px' };
        },
      cancel(){
        this.detailModal=false
      }
    }


}
</script>

  
  <style lang="scss" >
@import 'base_detail_modal.scss'; 

.base-modal{
        width: 100%;
        height: 700px;
        padding: 20px;
        .base-modal-line{
            width: 100%;
            height: auto;
            display: flex;
            gap:2%;
            align-items: center;
            justify-content: center;
            
            .item_1{
                width: 48%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_1-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_1-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            .item_2{
                width: 100%;
                height: auto;
                .item_2-title{
                    width: 100%;
                    color:#333333;
                }
            }

        }
    }
  </style>